export default __webpack_public_path__ + "static/media/640_dummy2016-kosmetik-mobile-de.043da8e8.png";